import type { ExportsFn } from '@wix/platform-editor-sdk';
import type {
  ComponentRef,
  EditorReadyFn,
  GetAppManifestFn,
} from '@wix/yoshi-flow-editor';

import profileCardConfig from './components/ProfileCard/.component.json';
import { createAppAPI } from './editor/services/app-api';
import { getEditorAPI } from './editor/services/editor-api';
import { globalAppState } from './editor/services/global-app-state';
import {
  getMembersAreaContext,
  MembersAreaContext,
} from './editor/services/members-area-api';
import { initMonitoring, toMonitored } from './editor/services/monitoring';
import * as publicApi from './editor/services/public-api';
import { maybeSetHorizontalLayout } from './editor/services/styles';

let appDefId: string;

const editorReady: EditorReadyFn = async (
  editorSDK,
  appDefinitionId,
  options,
  flowAPI,
) => {
  appDefId = appDefinitionId;
  globalAppState.setFlowAPI(flowAPI);
  initMonitoring(flowAPI.panoramaClient);

  if (!options.firstInstall) {
    return;
  }

  await toMonitored('setHorizontalLayout', () =>
    maybeSetHorizontalLayout(editorSDK, appDefId),
  );
};

const _exports: ExportsFn = (editorSDK) => ({
  public: {
    isHorizontalLayout: () => publicApi.isHorizontalLayout(editorSDK, appDefId),
    refreshApp: () => {
      return publicApi.refreshApp(editorSDK, 'PUBLIC_API_REFRESH');
    },
    setBooleanStyleParamForWidgets: (key: string, value: boolean) =>
      publicApi.setBooleanStyleParamForWidgets(editorSDK, appDefId, key, value),
    setHorizontalLayout: (widgetRef?: ComponentRef) =>
      publicApi.setHorizontalLayout(editorSDK, appDefId, widgetRef),
    setSidebarLayout: () => publicApi.setSidebarLayout(editorSDK, appDefId),
  },
  private: createAppAPI(editorSDK),
  editor: getEditorAPI(editorSDK),
});

export const getAppManifest: GetAppManifestFn = async (
  { appManifestBuilder },
  editorSDK,
  _contextParams,
  _flowAPI,
) => {
  const membersAreaContext = await getMembersAreaContext(editorSDK);
  const isMembersAreaV2 = membersAreaContext === MembersAreaContext.V2;
  const isMembersAreaV3 = membersAreaContext === MembersAreaContext.V3;

  return appManifestBuilder
    .configureWidget(profileCardConfig.id, (builder) => {
      builder.behavior().set({ removable: true });
      builder.gfpp().set('widgetPlugins', { behavior: 'HIDE' });
      if (isMembersAreaV2 || isMembersAreaV3) {
        builder
          .gfpp()
          .set('help', { id: 'a96ddc57-ab20-40d0-a39f-e1c0928c5c4e' });
      }
    })
    .build();
};

export { editorReady, _exports as exports };
